import { Cell, StandardGrid } from '@components/grid';
import * as React from 'react';
import styled from 'styled-components';

const SOCIAL_MEDIA = [
  {
    url: 'https://twitter.com/delphia',
    title: 'Twitter',
  },
  {
    url: 'https://www.facebook.com/delphiaAI',
    title: 'Facebook',
  },
  {
    url: 'https://www.instagram.com/delphia_ai',
    title: 'Instagram',
  },
];

const Footer = styled.footer`
  background: ${({ theme }) => theme.footer};
  padding: 32px 0;

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  h3 {
    font-family: primary-regular, sans-serif;
    color: ${({ theme }) => theme.color};
    margin-top: 0;
    margin-bottom: 32px;
  }

  a {
    font-family: primary-mono, monospace;
    color: ${({ theme }) => theme.nav.color};
    text-decoration: none;
    font-size: 14px;
    line-height: 24px;
  }
`;

const MobileFooter = () => (
  <Footer>
    <StandardGrid>
      <Cell>
        <h3>Follow us</h3>
        <ul>
          {SOCIAL_MEDIA.map(socialMedia => (
            <li key={socialMedia.title}>
              <a href={socialMedia.url}>{socialMedia.title}</a>
            </li>
          ))}
        </ul>
      </Cell>
    </StandardGrid>
  </Footer>
);

export default MobileFooter;
